<template>
  <div class="ban">
    <div class="demo-input-suffix" style="text-decoration: none;">
      <router-link to="/MyProducp">
        <span style="float:left；color: #8989ba;">
          <i class="el-icon-arrow-left"></i>
          Temporary inventory
        </span>
      </router-link>
    </div>

    <div class="demo-input-suffix">
      Selected
      <span id="num">0</span>
      <el-select v-model="Batchoperationvalue" clearable placeholder="Please choose" style="width:150px">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button style="background:#8989ba;color:#fff;outline: none" @click="Batchoperation">Batch operation</el-button>
      <span class="Synchronize">
        <el-input placeholder="SKU/商品名称" v-model="Queryproductvalue" @blur="Queryproduct" class="input"
          suffix-icon="el-icon-search"></el-input>
      </span>
    </div>

    <el-table ref="multipleTable" :data="tables" border style="width: 100%" @selection-change="handleSelectionChange"
      :row-key="getRowKeys">
      <el-table-column type="selection" :reserve-selection="true" :selectable="selectable" width="60" fixed="left">
      </el-table-column>
      <el-table-column prop="image" label="Image" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.image" min-width="70" height="70">
        </template>
      </el-table-column>
      <el-table-column prop="sku" label="SKU" show-overflow-tooltip></el-table-column>
      <el-table-column prop="desc_en" label="Product name"></el-table-column>
      <el-table-column prop="weight" label="Weight(g)"></el-table-column>
      <el-table-column prop="worth" sortable label="Value(USD)" width="120"></el-table-column>
      <el-table-column prop="status" :filters="status" :filter-multiple="false" :filter-method="filterstatus"
        filter-placement="right-start" show-overflow-tooltip>
        <template slot="header">
          <span>
            status
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                Description of product status
                <br>1.Synchronized-to-be-perfected information: Sku basic information is synchronized, but it needs to
                be perfected before it can be stored.
                <br>2.Warehousing: Products that have been put into storage and put on shelf, information can not be
                modified
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="inventory" label="numb" :filters="tab" :filter-method="filterTag" :filter-multiple="false"
        show-overflow-tooltip filter-placement="right-start"></el-table-column>
      <el-table-column label="Operation" width="300" fixed="right">
        <template slot-scope="scope">
          <a @click="perfect(scope)" v-if="scope.row.status=='unsynchronization'">edit</a>
          <a @click="Warehousing(scope)"
            v-if="scope.row.status=='Synchronization'||scope.row.status=='Warehoused'">Warehousing</a>
          <a @click="details(scope)"
            v-if="scope.row.status=='Synchronization'||scope.row.status=='Warehoused'">details</a>
          <a @click="remove(scope)">remove</a>
        </template>
      </el-table-column>
    </el-table>

    <div>
      <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <div id="details">
        <deta-ils :visible="addVisible" :companydata="companyList" @clearAdd="clearAdd"></deta-ils>
        <Edit-ing :visible="editVisible" :companydata="companyList" @clearEdit="clearEdit"></Edit-ing>
      </div>
    </div>
  </div>
</template>
<script>
import { getproduct, downproduct } from '../api/product'
import { setItem, getItem, removeItem } from '../../utils/locstorage'
import { getToken } from '../../utils/auth'
import store from '@/store'
import details from './details/details'
import Editing from './Editing/Editing'
export default {
  components: {
    'deta-ils': details,
    'Edit-ing': Editing
  },
  data () {
    return {
      nubm: '0',
      companyList: '',
      isActive: true,
      Queryproductvalue: '',
      Batchoperationvalue: '',
      keyword: '',
      total: 5,
      addVisible: false,
      editVisible: false,
      currentPage: 1,
      pageSize: 10,
      dormitory: [],
      multipleSelection: [],
      tab: [
        { text: 'In stock', value: 'In stock' },
        { text: 'Shortage', value: 'Shortage' }
      ],
      status: [
        { text: 'Unsynchronization', value: 'Unsynchronization' },
        { text: 'Synchronization', value: 'Synchronization' },
        { text: 'Warehoused', value: 'Warehoused' }
      ],
      options: [
        {
          value: '1',
          label: 'Warehousing'
        }
      ],
      value: ''
    }
  },
  created: function () {

  },
  mounted () {
    this.datalist()
    // this.$refs.multipleTable.toggleRowSelection(this.tableData[0],true);//默认选中
  },
  computed: {
    // 模糊搜索
    tables () {
      const search = this.Queryproductvalue
      if (search) {
        // filter() 方法创建一个新的数组，新数组中的元素是通过检查指定数组中符合条件的所有元素。
        // 注意： filter() 不会对空数组进行检测。
        // 注意： filter() 不会改变原始数组。
        return this.dormitory.filter(data => {
          // some() 方法用于检测数组中的元素是否满足指定条件;
          // some() 方法会依次执行数组的每个元素：
          // 如果有一个元素满足条件，则表达式返回true , 剩余的元素不会再执行检测;
          // 如果没有满足条件的元素，则返回false。
          // 注意： some() 不会对空数组进行检测。
          // 注意： some() 不会改变原始数组。
          return Object.keys(data).some(key => {
            // indexOf() 返回某个指定的字符在某个字符串中首次出现的位置，如果没有找到就返回-1；
            // 该方法对大小写敏感！所以之前需要toLowerCase()方法将所有查询到内容变为小写。
            if (key == 'sku' || key == 'desc_en') {
              return String(data[key]).indexOf(search) > -1
            }
          })
        })
      }
      return this.dormitory
    }
  },
  methods: {
    datalist () {
      let user = store.getters.shopTokenuser.customer_id
      let getItemsize = JSON.parse(getItem(user))
      console.log(getItemsize)
      if (getItemsize != null) {
        if (getItemsize.length > 0) {
          this.total = getItemsize.length
          // this.dormitory=getItemsize
          let param = {
            productid: getItemsize
          }
          getproduct(param)
            .then(response => {
              console.log(response)
              if (response.data.ask == 1) {
                this.dormitory = response.data.data
                // this.total = Number(response.data.count);
              }
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          this.dormitory = []
          this.total = 0
        }
      } else {
        this.dormitory = []
        this.total = 0
      }
    },

    filterTag (value, row) {
      console.log(row.inventory)
      if (value == 'In stock') {
        if (row.inventory != '/') {
          return row.inventory === row.inventory
        }
      } else {
        if (row.inventory == '/') {
          return row.inventory === row.inventory
        }
      }
    },
    selectable (row, index) {
      // console.log(row)
      if (row.productid != null && row.status != 'unsynchronization') {
        return true
      } else {
        return false
      }
    },
    getRowKeys (row) {
      return row.id
    },
    filterstatus (value, row) {
      return row.status === value
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(function (row) {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      console.log(val)
      document.getElementById('num').innerHTML = val.length
      this.multipleSelection = val
      this.nubm = val.length
    },
    callbackFunction (result) {
      alert(result + 'aaa')
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      // this.fetchData(1, val);
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // this.fetchData(val, this.pageSize);
      // console.log(`当前页: ${val}`);
    },
    // 批量操作
    Batchoperation () {
      if (this.Batchoperationvalue == '') {
        this.$message.error('Please choose the mode of operation.')
      } else if (this.multipleSelection.length == 0) {
        this.$message.error('Please select the operation object')
      } else {
        if (store.getters.status !== 'Certified') {
          this.$confirm(
            'The current user is not authenticated and cannot create an ASN Order?',
            'Tips',
            {
              confirmButtonText: 'Sure',

              type: 'warning'
            }
          )
            .then(() => {
              let param = {
                customer_id: store.getters.shopTokenuser.customer_id,
                secretkey: '3d878b3aeae9d5d389a7c82a27708c6a'
                //
              }
              gettokenuser(param)
                .then(response => {
                  this.loading = false
                  if (response.data.ask == 1) {
                    document.cookie =
                        'token=' +
                        response.data.token +
                        ';path=/;domain=.sendfromchina.com'
                    window.open('http://ffment.sendfromchina.com/activation/activation')
                  }
                })
                .catch(error => {
                  this.loading = false
                  console.log(error)
                })

                //
            })
            .catch(() => { })

          return
        }
        console.log(this.Batchoperationvalue)
        console.log(this.multipleSelection)
        let getItemsize = []
        console.log(444)
        let user = store.getters.shopTokenuser.customer_id
        let rowgetItemsize = JSON.parse(getItem(user))
        console.log(rowgetItemsize.length)
        for (let i = 0; i < this.multipleSelection.length; i++) {
          getItemsize.push(this.multipleSelection[i].productid)

          // for (let j = 0; j < rowgetItemsize.length; j++) {
          //   if (rowgetItemsize[j] != this.multipleSelection[i].productid) {
          //     console.log(rowgetItemsize[j]);
          //     let RgetItemsize = [];
          //     RgetItemsize.push(rowgetItemsize[j]);
          //     setItem(user, JSON.stringify(RgetItemsize));
          //   } else {
          //     removeItem(user);
          //   }
          // }
          //
        }

        for (let i = 0; i < rowgetItemsize.length; i++) {
          for (let j = 0; j < getItemsize.length; j++) {
            console.log(getItemsize[j])
            if (rowgetItemsize[i] == getItemsize[j]) {
              console.log(rowgetItemsize)
              // delete props.row.SPO_item[i]
              rowgetItemsize.splice(i, 1)
              console.log(rowgetItemsize)
            }
          }
        }
        setItem(user, JSON.stringify(rowgetItemsize))
        setItem('Warehousing', JSON.stringify(getItemsize))
        this.$router.push({ path: '/newans' })
      }
    },
    remove (scope) {
      console.log(scope)
      let user = store.getters.shopTokenuser.customer_id
      let getItemsize = JSON.parse(getItem(user))
      console.log(getItemsize)
      // console.log(this.dormitory)
      for (var i = 0; i < getItemsize.length; i++) {
        if (getItemsize[i] == scope.row.productid) {
          console.log(getItemsize)
          // delete props.row.SPO_item[i]
          getItemsize.splice(i, 1)
          setItem(user, JSON.stringify(getItemsize))
        }
      }
      this.datalist()
    },
    perfect (scope) {
      console.log(scope.row.productid)
      let param = {
        sku: scope.row.sku
      }
      getproduct(param)
        .then(response => {
          console.log(response)
          if (response.data.ask == 1) {
            console.log(response.data.data)
            this.companyList = response.data.data[0]
            this.editVisible = true
            console.log(this.companyList.desc_cn)
            // this.total = Number(response.data.count);
          }
        })
        .catch(error => {
          console.log(error)
        })

        // console.log(scope);
    },
    // 入库
    Warehousing (scope) {
      if (store.getters.status !== 'Certified') {
        this.$confirm(
          'The current user is not authenticated and cannot create an ASN Order?',
          'Tips',
          {
            confirmButtonText: 'Sure',

            type: 'warning'
          }
        )
          .then(() => {
            let param = {
              customer_id: store.getters.shopTokenuser.customer_id,
              secretkey: '3d878b3aeae9d5d389a7c82a27708c6a'
              //
            }
            gettokenuser(param)
              .then(response => {
                this.loading = false
                if (response.data.ask == 1) {
                  document.cookie =
                      'token=' +
                      response.data.token +
                      ';path=/;domain=.sendfromchina.com'
                  window.open('http://ffment.sendfromchina.com/activation/activation')
                }
              })
              .catch(error => {
                this.loading = false
                console.log(error)
              })

              //
          })
          .catch(() => { })

        return
      }

      console.log(scope)
      // let getItemsize = [];
      console.log(444)
      let user = store.getters.shopTokenuser.customer_id
      let getItemsize = JSON.parse(getItem(user))
      console.log(getItemsize)
      for (var i = 0; i < getItemsize.length; i++) {
        if (getItemsize[i] == scope.row.productid) {
          console.log(getItemsize)
          // delete props.row.SPO_item[i]
          getItemsize.splice(i, 1)
          setItem(user, JSON.stringify(getItemsize))
        }
      }
      let getItemsize1 = []
      getItemsize1.push(scope.row.productid)
      setItem('Warehousing', JSON.stringify(getItemsize1))

      this.$router.push({ path: '/newans' })
    },

    getproductlist (param) {
      getproduct(param)
        .then(response => {
          if (response.data.ask == 1) {
            this.tableData = response.data.data
            this.total = Number(response.data.count)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 详情
    details (scope) {
      console.log(scope.row.productid)
      let productid = []
      productid.push(scope.row.productid)
      let param = {
        productid
      }
      getproduct(param)
        .then(response => {
          console.log(response)
          if (response.data.ask == 1) {
            console.log(response.data.data)
            this.companyList = response.data.data[0]
            this.addVisible = true
            console.log(this.companyList.desc_cn)
            // this.total = Number(response.data.count);
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    // 查询商品
    Queryproduct () {
      console.log(this.Queryproductvalue)
    },
    // 同步shopify产品信息
    Synchronize () {
      this.isActive = false
    },
    clearAdd () {
      this.addVisible = false
    },
    clearEdit () {
      this.editVisible = false
    }
  }
}
</script>
<style>
  .Synchronize {
    float: right;
    font-size: 14px;
    color: #8989ba;
  }

  .ban {
    background: #fff;
    margin: 20px;
    padding: 20px;
  }

  .demo-input-suffix {
    padding-bottom: 20px;
    text-align: left;
  }

  .input {
    width: 200px;
  }

  .pagination {
    margin-top: 20px;
  }

  a {
    color: #8989ba;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/storage/storage.vue